export interface PageValues {
  tenantId?: string;
  domainId?: string;
  apiUrl?: string;
}

const MARKERS: [string, keyof PageValues][] = [
  ["{TENANT_ID}", "tenantId"],
  ["{DOMAIN_ID}", "domainId"],
  ["{API_URL}", "apiUrl"],
];

export const fillPageValues = (template: string, values: PageValues): string =>
  MARKERS.reduce((text, [marker, key]) => {
    const value = values[key];
    return value ? text.split(marker).join(value) : text;
  }, template);
